import baseCallEach from "../_internal/baseCallEach.js";
import mapC from "./mapC.js";
import objectC from "./objectC.js";

export default baseCallEach(mapC, objectC);
